export const ru = {
  // Common
  "common.back": "Назад",
  "common.cancel": "Отмена",
  "common.noItems": "Нет элементов",
  "common.loading": "Загрузка...",
  
  // Header
  "nav.features": "Функции",
  "nav.howItWorks": "Как это работает",
  "nav.pricing": "Цены",
  "nav.faq": "FAQ",
  "nav.testimonials": "Витрина",
  "nav.contact": "Контакты",
  "button.getStarted": "Начать",
  "button.loading": "Загрузка...",

  // Auth related
  "auth.signIn": "Войти",
  "auth.redirecting": "Перенаправление...",
  "auth.continueWithGoogle": "Продолжить с Google",
  "auth.continueWithGithub": "Продолжить с GitHub",
  "auth.or": "ИЛИ",
  "auth.consent.prefix": "Продолжая, вы соглашаетесь с нашими",
  "auth.consent.terms": "Условиями",
  "auth.consent.and": "и",
  "auth.consent.privacy": "Политикой конфиденциальности",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "ИИ-помощник для общения",
  "hero.subtitle": "Преобразуйте ваши разговоры с помощью умных, контекстно-зависимых ответов, которые помогают общаться более эффективно в любой ситуации.",
  "hero.cta.primary": "Начать бесплатный пробный период",
  "hero.cta.secondary": "Посмотреть демо",
  "hero.cta.tryNow": "Начать бесплатно",
  "hero.cta.learnMore": "Узнать больше",
  "hero.cta.getStarted": "Начать бесплатно",
  "hero.preview.primary": "Улучшить тон",
  "hero.preview.secondary": "Перевести",
  "hero.preview.tone": "Дружелюбный",
  "hero.preview.target": "Клиент",
  "hero.hook": "Присоединяйтесь к тысячам пользователей, которые улучшают свое общение каждый день.",
  "hero.headline": "ИИ-помощник для общения",
  "hero.subheadline": "Превратите сырые идеи в отшлифованные, контекстно-зависимые ответы за секунды.",
  
  // Stats
  "stats.users": "Пользователи",
  "stats.replies": "Ответы",
  "stats.languages": "Языки",

  // Main Title
  "main.title": "Превратите каждый ответ в возможность",

  // Footer Section
  "footer.company": "Компания",
  "footer.product": "Продукт",
  "footer.support": "Поддержка",
  "footer.legal": "Правовая информация",
  "footer.contactSupport": "Связаться с поддержкой",
  "footer.helpCenter": "Центр помощи",
  "footer.apiDocs": "Документация API",
  "footer.statusPage": "Страница статуса",
  "footer.privacyPolicy": "Политика конфиденциальности",
  "footer.termsOfService": "Условия обслуживания",
  "footer.cookiePolicy": "Политика cookies",
  "footer.refundPolicy": "Политика возврата",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Поддержка",

  // Features Section
  "features.badge": "Мощные функции",
  "features.title": "Всё необходимое для лучшего общения",
  "features.subtitle": "Комплексные инструменты, разработанные для того, чтобы сделать каждый разговор более эффективным и профессиональным.",
  "features.scenario.title": "Шаблоны сценариев",
  "features.scenario.description": "Готовые шаблоны для рабочего, личного, академического и профессионального общения.",
  "features.custom.title": "Пользовательский ввод",
  "features.custom.description": "Вставьте любое сообщение или контент и получите контекстно подходящие ответы.",
  "features.instant.title": "Сократите время ответа на 90%",
  "features.instant.description": "Получайте созданные ИИ ответы за несколько секунд. Никакого ожидания, только результаты.",
  "features.copy.title": "Копирование и обмен одним кликом",
  "features.copy.description": "Мгновенно копируйте ответы или делитесь ими прямо с платформы.",

  // How It Works Section
  "howItWorks.badge": "Как это работает",
  "howItWorks.title": "Три простых шага к лучшему общению",
  "howItWorks.subtitle": "Наш упрощенный процесс позволяет легко генерировать профессиональные ответы для любой ситуации.",
  "howItWorks.step1.title": "Выберите сценарий",
  "howItWorks.step1.description": "Выберите сценарий общения, который лучше всего подходит вашим потребностям.",
  "howItWorks.step2.title": "Вставьте контент",
  "howItWorks.step2.description": "Добавьте сообщение или контент, на который вам нужно ответить.",
  "howItWorks.step3.title": "Получите ответ ИИ",
  "howItWorks.step3.description": "Получите профессиональный, контекстный ответ за секунды.",

  // Pricing Section
  "pricing.title": "Цены",
  "pricing.subtitle": "Выберите план, который подходит вашим потребностям в общении",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/месяц",
  "pricing.free.description": "Идеально для знакомства с нашим сервисом",
  "pricing.pro.description": "Идеально для профессионалов и частых пользователей",
  "pricing.business.description": "Для команд и организаций",
  "pricing.popular": "Самый популярный",
  "pricing.free.feature1": "10 ответов в месяц",
  "pricing.free.feature2": "Базовый сценарий",
  "pricing.free.feature3": "Определение и использование шаблонов",
  "pricing.free.feature4": "Исторические записи ответов",
  "pricing.pro.feature1": "200 ответов в месяц",
  "pricing.pro.feature2": "Базовый+пользовательский сценарий",
  "pricing.pro.feature3": "Определение и использование шаблонов",
  "pricing.pro.feature4": "Исторические записи ответов",
  "pricing.pro.feature5": "Расширенная настройка",
  "pricing.business.feature1": "Неограниченные ответы",
  "pricing.business.feature2": "Командное сотрудничество",
  "pricing.business.feature3": "Базовый+пользовательский сценарий",
  "pricing.business.feature4": "Определение и использование шаблонов",
  "pricing.business.feature5": "Исторические записи ответов",
  "pricing.business.feature6": "Расширенная настройка",
  "pricing.cta.trial": "Начать бесплатный пробный период",
  "pricing.cta.subscribe": "Подписаться",
  "pricing.cta.contact": "Связаться с отделом продаж",
  "pricing.cta.current": "Текущий план",
  "pricing.currentPlan": "Текущий план:",
  "pricing.endDate": "Дата окончания текущего плана:",
  "pricing.autoRenewalDate": "Дата автопродления текущего плана:",
  "pricing.answersLeft": "Осталось ответов:",
  "pricing.planName.free": "План Free",
  "pricing.planName.proMonthly": "План Pro-Месячный",
  "pricing.planName.proYearly": "План Pro-Годовой",
  "pricing.planName.maxMonthly": "План Enterprise-Месячный",
  "pricing.planName.maxYearly": "План Enterprise-Годовой",
  "pricing.autoRenews": "Ваш счетчик ответов автоматически обновляется:",
  "pricing.needMore": "Нужно больше ответов?",
  "pricing.upgradeBelow": "Обновите свой план ниже",
  "pricing.doNotRollOver": "Неиспользованные ответы не переносятся",
  "pricing.willCancelOn": "Будет отменен:",
  "pricing.downgradeScheduled": "Планируется понижение. Переключится на",
  "pricing.on": "на:",
  "pricing.upgradeImmediateTitle": "План обновлен",
  "pricing.upgradeImmediateDesc": "Ваш новый план теперь активен.",
  "pricing.downgradeScheduledTitle": "Планируется понижение",
  "pricing.downgradeScheduledDesc": "Ваш план изменится при следующем продлении.",
  "pricing.cancelScheduledTitle": "Планируется отмена",
  "pricing.cancelScheduledDesc": "Ваш план закончится в конце периода.",
  "pricing.cancelResumedTitle": "Отмена удалена",
  "pricing.cancelResumedDesc": "Ваша подписка продолжит продлеваться.",
  "pricing.cancelPendingDowngrade": "Отменить",
  "pricing.pendingDowngradeCanceledTitle": "Планируемое понижение отменено",
  "pricing.pendingDowngradeCanceledDesc": "Ваш план останется без изменений.",
  "pricing.pendingDowngradeCancelFailedTitle": "Ошибка отмены",
  "pricing.pendingDowngradeCancelFailedDesc": "Не удалось отменить планируемое понижение. Пожалуйста, попробуйте еще раз.",
  "pricing.cancelPendingDowngradeProcessing": "Обработка...",
  "pricing.scheduled": "Запланировано",
  "pricing.processing": "Обработка...",
  "pricing.getMoreReplies": "Получить больше ответов",
  "pricing.oneTimeTitle": "Получить больше ответов на ваш аккаунт",
  "pricing.oneTimeAmountLabel": "Сумма (USD)",
  "pricing.repliesUnit": "Ответы",
  "pricing.oneTimeNotice": "Количество приобретённых ответов действительно в течение текущего месячного цикла. Для их использования требуется активная платная подписка, неиспользованные ответы не переносятся.",
  "pricing.cancel": "Отмена",
  "pricing.proceed": "Продолжить",
  "pricing.confirmUpgradeTitle": "Подтвердить обновление",
  "pricing.confirmDowngradeTitle": "Подтвердить понижение",
  "pricing.confirmUpgradeDesc": "Вы собираетесь обновить свой план. Изменения вступят в силу немедленно, может применяться пропорциональная плата (или кредит).",
  "pricing.confirmDowngradeDesc": "Вы собираетесь запланировать понижение. Ваши текущие функции остаются до конца текущего расчетного периода.",
  "pricing.downgradeEffectNote": "Понижение не возвращает средства за текущий цикл.",
  "pricing.downgradeApplyNextCycle": "Новый план автоматически начнет действовать при продлении.",
  "pricing.confirmCancel": "Назад",
  "pricing.confirmProceedUpgrade": "Обновить сейчас",
  "pricing.confirmProceedDowngrade": "Запланировать понижение",

  // FAQ Section
  "faq.title": "Часто задаваемые вопросы",
  "faq.subtitle": "Всё, что вам нужно знать о communicate2win",
  "faq.q1": "Какие сценарии общения поддерживаются?",
  "faq.a1": "Мы поддерживаем рабочее общение, личные отношения, академическую переписку, обслуживание клиентов, продажи и многие другие сценарии. Наш ИИ адаптируется к контексту и тону, необходимому для каждой ситуации.",
  "faq.q2": "Как быстро генерируются ответы?",
  "faq.a2": "Наш ИИ генерирует ответы за несколько секунд. Мы приоритизируем скорость, не жертвуя качеством, обеспечивая мгновенные профессиональные ответы.",
  "faq.q3": "Могу ли я отменить подписку в любое время?",
  "faq.a3": "Да, вы можете отменить подписку в любое время. Нет долгосрочных обязательств, и вы можете понизить или повысить свой план по мере необходимости.",
  "faq.q4": "Безопасны ли мои данные и конфиденциальны?",
  "faq.a4": "Да, мы реализуем комплексные меры безопасности, включая шифрование, контроль доступа и регулярные аудиты безопасности. Ваш входной контент и сгенерированные ответы хранятся как часть вашей пользовательской истории для включения функций, таких как просмотр ответов и создание шаблонов. Вы можете удалить данные истории в любое время через настройки аккаунта.",
  "faq.q5": "Что делать, если у меня закончились Replies?",
  "faq.a5": "Пользователи Free должны ждать следующего месячного цикла, чтобы квота обновилась. После перехода на Pro, если Replies закончились, можно купить дополнительные разовые Replies; они действуют только в текущем месячном цикле. Пользователи Enterprise имеют неограниченные Replies.",
  "faq.q6": "Какие языки поддерживаются?",
  "faq.a6": "В настоящее время мы поддерживаем английский с планами расширения на испанский, французский, немецкий и другие основные языки. ИИ может эффективно обрабатывать многоязычное общение.",

  // Testimonials Section
  "testimonials.title": "Витрина общения",
  "testimonials.subtitle": "Публичные сообщения, электронные письма и отшлифованные ИИ ответы для вашего вдохновения",
  "testimonials.sarah.name": "Сара Джонсон",
  "testimonials.sarah.title": "Директор по маркетингу",
  "testimonials.sarah.quote": "communicate2win преобразил то, как я обрабатываю клиентское общение. Ответы профессиональны и экономят мне часы каждую неделю.",
  "testimonials.michael.name": "Майкл Чен",
  "testimonials.michael.title": "Менеджер по продажам",
  "testimonials.michael.quote": "Шаблоны рабочих сценариев невероятно точны. Мой коэффициент ответов улучшился на 40% с тех пор, как я использую этот инструмент.",
  "testimonials.emily.name": "Эмили Родригес",
  "testimonials.emily.title": "Руководитель по успеху клиентов",
  "testimonials.emily.quote": "Идеально для обработки сложных клиентских ситуаций. ИИ прекрасно понимает контекст и тон.",
  "testimonials.more": "Нажмите на галерею, чтобы изучить полную витрину",

  // Interface Elements
  "interface.generating": "Генерация ответа...",
  "interface.generate": "Генерировать ответ ИИ",
  "interface.processing": "Обработка...",
  "interface.advancedOptions": "Расширенные опции",
  "interface.clearInput": "Очистить ввод",
  "interface.clearDescription": "Очистить описание",
  // Marquee / Logos
  "marquee.trusted": "Партнёры / Поддержка",
  "marquee.aria": "Логотипы брендов",

  // History and Showcase
  "history.shareToShowcase": "Поделиться в витрине",
  "history.showcased": "В витрине",
  "history.shareConfirm": "Поделиться этой публикацией в витрине? Это действие нельзя отменить, если только вы не удалите публикацию.",
  "history.sharedBy": "Поделился:",
  "interface.copy": "Копировать",
  "interface.share": "Поделиться",
  "interface.shareResponse": "Поделиться ответом",
  "interface.shareNative": "Поделиться через систему",
  "interface.shareEmail": "Электронная почта",
  "interface.copyShareText": "Копировать со ссылкой",
  "interface.shareTextCopied": "Ответ и ссылка скопированы в буфер обмена.",
  "interface.ready": "Готов к генерации",
  "interface.enterMessage": "Введите содержание сообщения и выберите сценарий, чтобы начать с ответов на основе ИИ.",
  "interface.fast": "Быстро",
  "interface.accurate": "Точно",
  "interface.professional": "Профессионально",
  "interface.translation": "Перевод",
  "interface.responseDescription": "Вот продуманный и профессиональный ответ, адаптированный к контексту:",
  "interface.multipleOptions": "Несколько вариантов ответа:",
  "interface.option": "Вариант",
  "interface.noContent": "Контент недоступен",

  // Placeholders
  "placeholder.message": "Вставьте сообщение, на которое отвечаете, содержание электронной почты или полученный текст...",

  // Dropdowns
  "dropdown.useTemplates": "Использовать шаблоны",
  "dropdown.scenario": "Без сценария",
  "dropdown.target": "Без цели",
  "dropdown.tone": "Без тона",

  // Scenario Options
  "scenario.email": "Электронная почта",
  "scenario.message": "Сообщение",
  "scenario.workplace": "Рабочее место",
  "scenario.school": "Школа",
  "scenario.home": "Дом",
  "scenario.business": "Бизнес",
  "scenario.academic": "Академический",
  "scenario.social": "Социальный",
  "scenario.formal": "Формальный",
  "scenario.casual": "Неформальный",
  "scenario.professional": "Профессиональный",
  "scenario.personal": "Личный",
  "scenario.customerService": "Обслуживание клиентов",
  "scenario.interview": "Интервью",
  "scenario.presentation": "Презентация",

  // Target Options
  "target.lover": "Возлюбленный",
  "target.friend": "Друг",
  "target.boss": "Начальник",
  "target.colleague": "Коллега",
  "target.classmate": "Одноклассник",
  "target.parents": "Родители",
  "target.child": "Ребенок",
  "target.teacher": "Учитель",
  "target.student": "Студент",
  "target.client": "Клиент",
  "target.customer": "Покупатель",
  "target.stranger": "Незнакомец",
  "target.family": "Семья",
  "target.sibling": "Брат/сестра",
  "target.neighbor": "Сосед",
  "target.mentor": "Наставник",
  "target.supplier": "Поставщик",
  "target.serviceProvider": "Поставщик услуг",
  "target.partner": "Партнер",
  "target.subordinate": "Подчиненный",

  // Tone Options
  "tone.humorous": "Юмористический",
  "tone.serious": "Серьезный",
  "tone.happy": "Счастливый",
  "tone.angry": "Сердитый",
  "tone.mischievous": "Озорной",
  "tone.polite": "Вежливый",
  "tone.casual": "Неформальный",
  "tone.formal": "Формальный",
  "tone.friendly": "Дружелюбный",
  "tone.confident": "Уверенный",
  "tone.apologetic": "Извиняющийся",
  "tone.enthusiastic": "Восторженный",

  // Status Messages
  "status.copied": "Скопировано!",
  "status.copyDescription": "Ответ скопирован в буфер обмена.",
  "status.copyWithTranslationDescription": "Ответ и перевод скопированы в буфер обмена.",
  "status.success": "Ответ успешно сгенерирован.",
  "status.successWithTranslation": "Ответ сгенерирован с переводом.",
  "status.successWithoutTranslation": "Ответ успешно сгенерирован.",
  "status.error": "Генерация не удалась",
  "status.errorDescription": "Не удалось сгенерировать ответ. Попробуйте еще раз.",
  "status.enterContent": "Пожалуйста, введите контент",
  "status.enterContentDescription": "Добавьте сообщение, на которое хотите ответить.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Описание (необязательно)",
  "restriction.descriptionLabel": "Описание (Только для подписчиков Pro / Enterprise)",
  "restriction.proMaxOnly": "* Только для подписчиков Pro / Enterprise",
  "restriction.desPrompt": "Введите контекст, справочную информацию или конкретные требования, которые могут помочь генерировать лучшие ответы...",

  // Demo functionality for non-logged-in users
  "demo.title": "Выберите сообщение для ответа",
  "demo.option1": "Открытие продаж (холодный подход)",
  "demo.option2": "Обработка зондирования \"ваша цена высока\"",
  "demo.option3": "Самопрезентация на собеседовании (30-секундная версия)",
  "demo.option4": "Ответ по электронной почте",
  "demo.option5": "Последующие действия для перспективы \"прочитано-но-нет-ответа\"",
  "demo.option6": "Elevator pitch (30 секунд)",
  "demo.runDemo": "Запустить Демо",
  "demo.inputContent": "Входной Контент:",
  "demo.scenario": "Сценарий:",
  "demo.target": "Цель:",
  "demo.tone": "Тон:",
  "demo.description": "Описание:",

  // Showcase Page
  "showcase.title": "Витрина общения",
  "showcase.subtitle": "Откройте для себя вдохновляющие коммуникации с ИИ, которыми поделилось наше сообщество",
  "showcase.userPrefix": "Публичные коммуникации от",
  "showcase.backAll": "Вернуться ко всей витрине",
  "showcase.sortBy": "Сортировать по:",
  "showcase.sort.newest": "Сначала новые",
  "showcase.sort.oldest": "Сначала старые",
  "showcase.sort.scenario": "По сценарию",
  "showcase.sort.target": "По цели",
  "showcase.sort.tone": "По тону",
  "showcase.filter.scenario": "Сценарий:",
  "showcase.filter.target": "Цель:",
  "showcase.filter.tone": "Тон:",
  "showcase.filter.all": "Все",
  "showcase.loading": "Загрузка витрины...",
  "showcase.loadingUser": "Загрузка коммуникаций пользователя...",
  "showcase.loadingMore": "Загрузка дополнительных...",
  "showcase.none.userTitle": "Пока нет публичных коммуникаций",
  "showcase.none.globalTitle": "Пока нет элементов витрины",
  "showcase.none.userDesc": "Этот пользователь еще не поделился коммуникациями во витрине.",
  "showcase.none.globalDesc": "Станьте первым, кто поделится своей ИИ-коммуникацией во витрине!",
  "showcase.messageDetails": "Детали сообщения",
  "showcase.field.date": "Дата",
  "showcase.field.scenario": "Сценарий",
  "showcase.field.target": "Цель",
  "showcase.field.tone": "Тон",
  "showcase.originalMessage": "Оригинальное сообщение",
  "showcase.description": "Описание",
  "showcase.aiResponse": "Ответ ИИ",

  // Templates
  "templates.saveAsTemplate": "Сохранить как шаблон",
  "templates.saved": "Шаблон сохранен",
  "templates.saveSuccess": "Шаблон успешно сохранен",
  "templates.title": "Мои шаблоны",
  "templates.new": "Новый шаблон",
  "templates.loading": "Загрузка...",
  "templates.none": "Шаблоны не найдены",
  "templates.name": "Название",
  "templates.scenario": "Сценарий",
  "templates.target": "Цель",
  "templates.tone": "Тон",
  "templates.description": "Описание",
  "templates.save": "Сохранить",
  "templates.saving": "Сохранение...",
  "templates.delete": "Удалить шаблон",
  "templates.deleteConfirm": "Удалить этот шаблон?",
  "templates.deleteFailed": "Не удалось удалить шаблон",
  "templates.nameRequired": "* Пожалуйста, введите название шаблона",
  "templates.deleteSuccess": "Шаблон успешно удален",
  "templates.saveFailed": "Не удалось сохранить шаблон",

  // History Modal additions
  "history.messageDetails": "Детали сообщения",
  "history.messageDetailsDesc": "Просмотр и управление деталями сообщения, включая исходный ввод и ответ ИИ.",
  "history.field.date": "Дата",
  "history.field.scenario": "Сценарий",
  "history.field.target": "Цель",
  "history.field.tone": "Тон",
  "history.originalMessage": "Оригинальное сообщение",
  "history.aiResponse": "Ответ ИИ",
  "history.description": "Описание",
  "history.listTitle": "История сообщений",
  "history.listDesc": "Просмотр, фильтрация и управление историей разговоров. Нажмите на любое сообщение для просмотра деталей.",
  "history.sortBy": "Сортировать по:",
  "history.sort.newest": "Сначала новые",
  "history.sort.oldest": "Сначала старые",
  "history.sort.scenario": "По сценарию",
  "history.sort.target": "По цели",
  "history.sort.tone": "По тону",
  "history.filter.scenario": "Сценарий:",
  "history.filter.target": "Цель:",
  "history.filter.tone": "Тон:",
  "history.filter.all": "Все",
  "history.loading": "Загрузка истории...",
  "history.loadingMore": "Загрузка дополнительных...",
  "history.none": "Сообщения не найдены",
  "history.showing": "Показано {current} из {total} сообщений",
  "history.allLoaded": "Все сообщения загружены",
  "history.scrollMore": "Прокрутите вниз для большего",
  "history.loadMoreButton": "Загрузить Ещё",
  "history.deleteMessage": "Удалить сообщение",
  "history.deleting": "Удаление...",
  "history.deleteSuccess": "Запись сообщения успешно удалена",
  "history.deleteFailed": "Не удалось удалить запись сообщения, попробуйте еще раз",
  "history.confirmDeleteTitle": "Подтвердить удаление",
  "history.confirmDeleteSubtitle": "Это действие нельзя отменить",
  "history.confirmDeleteDesc": "Вы уверены, что хотите удалить эту запись сообщения?",
  "history.confirmDeleteAction": "Подтвердить удаление",
  "history.shareTitle": "Поделиться во витрине",
  "history.shareSubtitle": "Сделать это сообщение публичным",
  "history.sharing": "Публикация...",
  "history.confirmShareAction": "Подтвердить публикацию",
  "history.shareSuccess": "Сообщение успешно опубликовано во витрине",
  "history.shareFailed": "Не удалось опубликовать во витрине, попробуйте еще раз",

  // User Menu
  "userMenu.myAccount": "Мой Аккаунт",
  "userMenu.history": "История",
  "userMenu.templates": "Шаблоны",
  "userMenu.signOut": "Выйти",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Предварительный просмотр ответа ИИ",
  "hero.preview.scenarioLabel": "Сценарий",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Открытие продаж",
  "demo.shortTitle.priceObjection": "Возражение по цене",
  "demo.shortTitle.interviewIntro": "Вступление к интервью",
  "demo.shortTitle.emailReply": "Ответ по электронной почте",
  "demo.shortTitle.followUp": "Последующие действия",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "демо",
  "demoTabs.response": "ответ",
  "demoTabs.inputPrompt": "ПОДСКАЗКА ВВОДА",
  "demoTabs.context": "КОНТЕКСТ",
  "demoTabs.description": "Описание",
  "demoTabs.generate": "Генерировать",
  "demoTabs.aiOutput": "ВЫВОД ИИ",
  "demoTabs.sample": "образец",
  "demoTabs.streaming": "Потоковая передача токенов...",
  "preview.section.scenarioTemplates.title": "Сценарии и шаблоны",
  "preview.section.scenarioTemplates.subtitle": "Быстро выберите сценарий или примените сохраненный шаблон. Шаблоны предварительно заполняют описание/цель/тон, так что вы сразу попадаете в высококачественную генерацию.",
  "preview.section.customInputs.title": "Пользовательский ввод",
  "preview.section.customInputs.subtitle": "Основной ввод + необязательное описание + расширенные селекторы сценариев/целей/тона. Свободно комбинируйте для получения контекстно-зависимых результатов.",
  "preview.section.cutReplyTime.title": "Сократите время ответа на 90%",
  "preview.section.cutReplyTime.subtitle": "Сравните ручное создание черновиков с помощью ИИ. Параллельные опции + встроенные циклы перевода или редактирования.",
  "preview.section.copyShare.title": "Копирование и обмен одним кликом",
  "preview.section.copyShare.subtitle": "Несколько опций, упорядоченных с едиными верхними действиями: копировать всё / поделиться / копировать по опциям. Перевод прикрепляется автоматически.",
  "preview.templates.my": "Мои шаблоны",
  "preview.templates.new": "Новый",
  "preview.manualFlow": "Ручной поток",
  "preview.aiAssisted": "С поддержкой ИИ",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Спланируйте структуру и тон",
  "preview.manualFlow.step2": "Создайте черновик вступления / удалите и перепишите",
  "preview.manualFlow.step3": "Отрегулируйте вежливость и грамматику",
  "preview.manualFlow.step4": "Поищите лексику + проверьте перевод",
  "preview.manualFlow.step5": "Вставьте в целевое приложение",
  "preview.copyAll": "Копировать всё",
  "preview.share": "Поделиться",
  "preview.enPlusTranslation": "EN + Перевод",
  "preview.translationAppendNote": "(*) Перевод прикрепляется автоматически при копировании всего.",
  "preview.field.scenario": "Сценарий",
  "preview.field.target": "Цель",
  "preview.field.tone": "Тон",
  "preview.auto": "Автоматически",
  "preview.step.pasteOrTemplate": "Вставьте запрос или выберите шаблон",
  "preview.step.optionalDescription": "(Необязательно) добавьте описание/сценарий",
  "preview.step.pickOption": "Выберите один из сгенерированных вариантов",
  "preview.step.copyShareTranslate": "Копировать/поделиться/перевести одним кликом",
  "preview.time.manual": "5–8 минут",
  "preview.time.ai": "30–40 секунд"
};